import { FormResponseStatus } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';

const formResponseStatusColorName = (status: FormResponseStatus) => {
  switch (status) {
    case FormResponseStatus.Pending:
      return { color: 'gray', label: 'Pending' };
    case FormResponseStatus.Processing:
      return { color: 'yellow', label: 'Processing' };
    case FormResponseStatus.Success:
      return { color: 'green', label: 'Success' };
    case FormResponseStatus.Failed:
      return { color: 'red', label: 'Failed' };
  }
};

interface FormResponseStatusTagProps extends ChakraV3.TagProps {
  status: FormResponseStatus;
}

export const FormResponseStatusTag = (props: FormResponseStatusTagProps) => {
  const { status, ...rest } = props;

  const { color, label } = formResponseStatusColorName(status);

  return (
    <ChakraV3.Tag colorPalette={color} {...rest}>
      {label}
    </ChakraV3.Tag>
  );
};
